import { ZohoServise } from './../services/answer/zoho.service';
import { FormBuilderService } from './../services/form-builder.service';
import { FormService } from '../services/form.service';
import { CarsService } from '../services/cars.service';
import { ClientQuestionsService } from '../services/client-questions.service';
import { UsersService } from '../services/users.service';
import { NgModule } from '@angular/core';
import { AnswerService } from '../services/answer/answer.service';
import { ComparisonService } from '../services/comparison/comparison.service';
import { FormProfilesService } from '../services/form-profiles.service';
import {CookieService} from "ngx-cookie-service";

@NgModule({
  providers: [
    CarsService,
    ClientQuestionsService,
    UsersService,
    FormService,
    FormProfilesService,
    FormBuilderService,
    AnswerService,
    ComparisonService,
    ZohoServise,
    CookieService
  ]
})
export class ServicesModule { }
